var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconAutoLocationGreen(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 53,
    height: 60,
    viewBox: "0 0 53 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.8686 14.1552C18.1682 14.1558 13.5104 16.176 14 20.2128L15.2 28.9872C15.4112 30.5316 16.454 33 18.0128 33H18.1238L19.4 48.318C19.4552 48.9798 19.9352 49.518 20.6 49.518H25.4C26.0648 49.518 26.5448 48.9798 26.6 48.318L27.8762 33H27.9872C29.5454 33 30.5888 30.531 30.8 28.9872L32 20.2128C32.3138 16.1724 27.5696 14.154 22.8686 14.1552V14.1552Z",
    fill: "#A6E327"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.0144 30.5448L22.9856 30.6204C22.9952 30.5976 23.0018 30.5742 23.0114 30.5514L23.0144 30.5448V30.5448ZM13.4036 41.4342C4.928 42.6318 -1 45.4968 -1 49.7142C-1 55.395 8.9048 60 23 60C37.0952 60 47 55.395 47 49.7142C47 45.4968 41.0726 42.6318 32.5976 41.4342L31.4234 43.4334C37.811 44.3196 42.2 46.182 42.2 48.3432C42.2 51.3732 33.6038 53.829 23 53.829C12.3962 53.829 3.8 51.3732 3.8 48.3432C3.7994 46.1892 8.1596 44.3286 14.567 43.4388C14.18 42.7704 13.7906 42.1032 13.403 41.4342H13.4036Z",
    fill: "#A6E327"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23 12.6C26.4794 12.6 29.3 9.77939 29.3 6.3C29.3 2.82061 26.4794 0 23 0C19.5206 0 16.7 2.82061 16.7 6.3C16.7 9.77939 19.5206 12.6 23 12.6Z",
    fill: "#A6E327"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAutoLocationGreen);
export default __webpack_public_path__ + "static/media/icon-autoLocationGreen.8a86922eca2be9596f79212c9df0ddf9.svg";
export { ForwardRef as ReactComponent };